import React, { useEffect, useState } from "react";
import DataTableBase from "../../../Components/Common/DataTableBase/DataTableBase";
import { t } from "i18next";
import { useKitchenStore } from "../../../stores/Assets/kitchen";
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  UncontrolledTooltip,
} from "reactstrap";
import AddKitchen from "./Components/AddKitchen";
import EditKitchen from "./Components/EditKitchen";
import ManageStationView from "../../MySpaces/components/ManageStationView";
import DistributionWizardModal from "./Components/DistributionWizardModal";
import { Link, useNavigate } from "react-router-dom";
import { useConfirmDialogStore } from "../../../stores/Modal/ConfirmDialogStore";
import { OpeningHours } from "./Components/OpeningHours";
import ShowToken from "./Components/ShowToken";
import { useSiteStore } from "../../../stores/Assets/site";
import { Pagination } from "../../../Components/Common/DataTableBase/Pagination";
import { canEdit } from "../../../helpers/permissions";
import SearchBar from "../../../Components/Common/SearchBar";
import Skeleton from "../../../Components/Common/Skeleton";
import { useUsageStore } from "../../../stores/Usage";
import { getMaxServiceLevel } from "../../../helpers/planLimits";
import { PlanUpgradeModal } from "../../../Components/Common/PlanUpgradeModal";
import { useAuth } from "../../../stores/Auth/Auth";

const Kitchens = () => {
  const [totalRows, setTotalRows] = useState(0);
  const [currentPage, setCurrentPage] = useState(1); // Track the current page
  const rowsPerPage = 10; // Display 5 rows per page
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(false);
  document.title = "Clickorder Admin";
  const navigate = useNavigate();
  const [showOpeningHoursModal, setshowOpeningHoursModal] = useState(false);
  const [showTokenModal, setShowTokenModal] = useState(false);
  const [selectedInfo, setselectedInfo] = useState("");
  const [selectedToken, setselectedToken] = useState("");
  const [kitchenId, setKitchenID] = useState("");
  const {
    getKitchens,
    getKitchensBySite,
    isLoading,
    pagination,
    kitchens,
    deleteKitchen,
  } = useKitchenStore((state) => state);
  const { usage, fetchUsage, getLimitInfo } = useUsageStore();
  const user = useAuth((state) => state.user);
  const stationLimit = getLimitInfo("stations");
  const isLimitReached = stationLimit?.isReached;

  useEffect(() => {
    if (usage && getMaxServiceLevel(usage) < 3 && user?.role !== 'ROOT') {
      navigate("/dashboard");
    }
  }, [usage, user, navigate]);

  const { getSites } = useSiteStore((state) => state);
  const [sites, setSites] = useState([]); // State to hold sites
  const [selectedSiteId, setSelectedSiteId] = useState("All"); // State for selected site
  const [filteredKitchens, setFilteredKitchens] = useState([]); // State for filtered kitchens
  const [showSiteError, setShowSiteError] = useState(false);

  useEffect(() => {
    const fetchSites = async () => {
      setLoading(true);
      const siteList = await getSites(); // Fetch sites
      setSites(siteList);
      setLoading(false);
    };

    fetchSites(); // Call the fetch function

    getKitchens({ page: 1, perPage: rowsPerPage }); // Fetch kitchens
  }, [getKitchens, getSites]);

  useEffect(() => {
    const filterKitchens = () => {
      fetchUsage();


      if (selectedSiteId === "All") {
        getKitchens({ page: 1, perPage: rowsPerPage, search: searchTerm }); // Fetch kitchens
      } else {
        // Filter kitchens by selected site ID

        getKitchensBySite(selectedSiteId, { page: 1, perPage: rowsPerPage, search: searchTerm });
      }
    };

    filterKitchens();
  }, [selectedSiteId, searchTerm]);

  useEffect(() => {
    setTotalRows(pagination?.totalItems || 0);
  }, [pagination]);

  const handleScheduleClick = (row) => {
    setselectedInfo(row);
    setshowOpeningHoursModal(!showOpeningHoursModal);
  };
  const handleTokenClick = (row) => {
    setselectedToken(row?.token);
    setKitchenID(row?.kitchen_id);
    setShowTokenModal(!showTokenModal);
  };

  const columns = [
    //add id column
    {
      name: t("ID"),
      width: "80px",
      selector: (row) => row?.kitchen_id,
      sortable: true,
      wrap: true,
    },
    {
      name: t("Site"),
      // width: "100px",
      selector: (row) => row?.site_id,
      sortable: true,
      wrap: true,
      cell: (row) => (
        <div className="d-flex flex-row justify-content-center align-items-center gap-2">
          <span>
            {row?.site?.name} (id: {row?.site?.site_id})
          </span>
        </div>
      ),
    },

    {
      name: t("Name"),
      // width: "100px",
      selector: (row) => row?.name,
      sortable: true,
      wrap: true,
      cell: (row) => (
        <div className="d-flex flex-row justify-content-center align-items-center gap-2">
          <span>{row?.name}</span>
        </div>
      ),
    },

    {
      name: t("Name (AR)"),
      // width: "100px",
      selector: (row) => row?.name,
      sortable: true,
      wrap: true,
      cell: (row) => (
        <div className="d-flex flex-row justify-content-center align-items-center gap-2">
          <span>{row?.name_ar}</span>
        </div>
      ),
    },
    {
      name: t("Status"),
      width: "100px",
      selector: (row) => row?.isOpen,
      sortable: true,
      wrap: true,
      cell: (row) => (
        <div
          style={{ fontSize: "14px" }}
          className={`badge cursor-normal bg-soft-${row.isOpen ? "success" : "danger"
            } text-${row.isOpen ? "success" : "danger"}`}
        >
          {row.isOpen ? "Open" : "Closed"}
        </div>
      ),
    },

    {
      name: t("Opening Hours"),
      width: "150px",

      selector: (row) => row?.isWeeklyTimingOn,
      sortable: true,
      wrap: true,
      cell: (row) => (
        <div className="cursor-pointer text-center align-items-center justify-content-center d-flex" id={`anchor-${row?.kitchen_id}`}>
          <span
            style={{ fontSize: "14px" }}
            className={`badge bg-soft-${row?.isWeeklyTimingOn ? "info" : "warning"
              } cursor-pointer text-${row?.isWeeklyTimingOn ? "success" : "warning"
              } text-uppercase`}
            onClick={() => handleScheduleClick(row)}
          >
            {<i className="ri-external-link-line"></i>}{" "}
            {row?.isWeeklyTimingOn ? "Hours" : "None"}
          </span>
          <UncontrolledTooltip
            placement="top"
            target={`anchor-${row?.kitchen_id}`}
          >
            {row?.openingHours?.length > 0
              ? "Check Associated Options"
              : "No options available"}
          </UncontrolledTooltip>
        </div>
      ),
    },
    {
      name: t("Token"),
      width: "110px",

      selector: (row) => row?.token,
      sortable: true,
      wrap: true,
      cell: (row) => (
        <div className="cursor-pointer" id={`anchor-${row?.token}`}>
          <span
            style={{ fontSize: "14px" }}
            className={`badge bg-soft-success cursor-pointer text-success text-uppercase`}
            onClick={() => handleTokenClick(row)}
          >
            {<i className="ri-external-link-line"></i>} Token
          </span>
          <UncontrolledTooltip placement="top" target={`anchor-${row?.token}`}>
            Check Associated Token
          </UncontrolledTooltip>
        </div>
      ),
    },
    {
      name: t("Tablets"),
      width: "120px",
      selector: (row) => row?.kitchen_id,
      sortable: false,
      wrap: true,
      cell: (row) => (
        <div 
          className="cursor-pointer" 
          id={`tablets-btn-${row?.kitchen_id}`}
          onClick={() => navigate(`/kitchens/${row?.kitchen_id}/tablets`)}
        >
          <span
            style={{ fontSize: "14px" }}
            className={`badge bg-soft-info cursor-pointer text-info text-uppercase`}
          >
            {<i className="ri-device-line"></i>} Tablets
          </span>
          <UncontrolledTooltip 
            placement="top" 
            target={`tablets-btn-${row?.kitchen_id}`}
          >
            View Connected Tablets
          </UncontrolledTooltip>
        </div>
      ),
    },
    {
      name: t("App Settings"),
      width: "150px",
      selector: (row) => row?.kitchen_id,
      sortable: false,
      wrap: true,
      cell: (row) => (
        <div
          className="cursor-pointer"
          id={`app-settings-btn-${row?.kitchen_id}`}
          onClick={() => navigate(`/kitchens/${row?.kitchen_id}/app-settings`)}
        >
          <span
            style={{ fontSize: "14px" }}
            className="badge bg-soft-primary cursor-pointer text-primary text-uppercase"
          >
            {<i className="ri-settings-3-line"></i>} {t("Settings")}
          </span>
          <UncontrolledTooltip
            placement="top"
            target={`app-settings-btn-${row?.kitchen_id}`}
          >
            {t("Service app settings")}
          </UncontrolledTooltip>
        </div>
      ),
    },
  ];


  const { showConfirm } = useConfirmDialogStore((state) => state);

  const [showAddKitchenModal, setShowAddKitchenModal] = useState(false);
  const [showEditKitchenModal, setShowEditKitchenModal] = useState(false);
  const [showManageStationWizard, setShowManageStationWizard] = useState(false);
  const [showUpgradeModal, setShowUpgradeModal] = useState(false);
  const toggleUpgradeModal = () => setShowUpgradeModal(!showUpgradeModal);

  const toggleAddKitchenModal = () => {
    if (!showAddKitchenModal && isLimitReached) {
      setShowUpgradeModal(true);
      return;
    }
    if (sites.length === 0) {
      setShowSiteError(true);
      return;
    }
    setShowAddKitchenModal(!showAddKitchenModal);
  };
  const toggleShowTokenModal = () => {
    setShowTokenModal(!showTokenModal);
  };

  const [selectedRow, setSelectedRow] = useState(null);

  const toggleEditKitchenModal = (row) => {
    setSelectedRow(row);
    setShowEditKitchenModal(!showEditKitchenModal);
  };

  const toggleManageStationWizard = (row) => {
    setSelectedRow(row);
    setShowManageStationWizard(!showManageStationWizard);
  };

  const onChangePage = (page) => {
    if (selectedSiteId === "All") {
      getKitchens({
        page: page,
        perPage: rowsPerPage,
        search: searchTerm,
      });
    } else {
      getKitchensBySite(selectedSiteId, { page: page, perPage: rowsPerPage, search: searchTerm });
    }
    setCurrentPage(page);
  };

  const searchHandler = (searchText) => {
    setSearchTerm(searchText);
    setCurrentPage(1); // Reset to first page on search
  };

  const deleteKitchenFun = async (id) => {
    try {
      await deleteKitchen(id);
      fetchUsage();
    } catch (e) {
      console.log(e);
    }
  };
  const handleSiteSelect = (e) => {
    setSelectedSiteId(e.target.value);
  };



  const onPageChange = (page) => {
    setCurrentPage(page);
  };
  const [canEditKitchen, setCanEditKitchen] = useState(false);

  useEffect(() => {
    const checkPermission = async () => {
      const res = await canEdit("kitchen");
      setCanEditKitchen(res);
    };

    checkPermission();
  }, []);

  return (
    <>
      {showSiteError && (
        <Modal isOpen={showSiteError} toggle={() => setShowSiteError(false)}>
          <ModalHeader>No Registered Site</ModalHeader>
          <ModalBody>
            <div className="text-center">
              <p className="text-danger">{t("You should first add a site.")}</p>
              <Link to="/sites" className="btn btn-primary">
                {t("Add a Site")}
              </Link>
            </div>
          </ModalBody>
        </Modal>
      )}
      <DataTableBase
        tableTitle={"Service Stations"}
        customHeader={
          <div className="w-100">
            {/* {isLimitReached && (
              <div
                className="alert alert-warning d-flex align-items-center justify-content-between py-2 px-3 mb-3 border-0 rounded-3 shadow-sm"
                style={{ backgroundColor: "rgba(255, 191, 0, 0.1)" }}
              >
                <div className="d-flex align-items-center">
                  <i className="ri-error-warning-fill fs-18 text-warning me-2"></i>
                  <span className="text-dark fw-medium">
                    {t("You have reached your service station limit ({{current}}/{{limit}}).", {
                      current: stationLimit.limit,
                      limit: stationLimit.limit
                    })}
                  </span>
                </div>
                <Button
                  color="warning"
                  size="sm"
                  className="rounded-pill px-3 fw-bold border-0 shadow-sm"
                  onClick={toggleUpgradeModal}
                  style={{ backgroundColor: "#c59253" }}
                >
                  {t("Upgrade Now")}
                </Button>
              </div>
            )} */}
            {loading ? (
              // Skeleton loading state
              <div className="d-flex flex-column flex-md-row align-items-stretch justify-content-between gap-2 w-100 mb-2">
                <div className="w-100" style={{ flex: '0 0 10%' }}>
                  <Skeleton variant="button" />
                </div>
                <div className="d-flex flex-column flex-md-row align-items-stretch gap-2 w-100 px-2" style={{ flex: '0 0 60%' }}>
                  <div className="d-flex align-items-center gap-2 w-100">
                    <h6 className="text-nowrap mb-0">Search: </h6>
                    <div className="flex-grow-1">
                      <Skeleton variant="input" />
                    </div>
                  </div>
                  <div className="d-flex align-items-center gap-2 w-100">
                    <h6 className="text-nowrap mb-0">Site: </h6>
                    <div className="flex-grow-1">
                      <Skeleton variant="input" />
                    </div>
                  </div>
                </div>

              </div>
            ) : (
              <div className="d-flex flex-column flex-md-row align-items-stretch justify-content-between gap-2 w-100 mb-2">
                <div className="d-flex gap-2 align-items-center">
                  {canEditKitchen ? (
                    <>
                      <Button
                        color={isLimitReached ? "secondary" : "success"}
                        onClick={toggleAddKitchenModal}
                        className="d-flex align-items-center justify-content-center"
                        style={{ padding: '0.4rem 2rem', whiteSpace: 'nowrap', fontSize: "13px" }}
                        id="add-station-btn"
                      >
                        + {t("Add Station")}
                      </Button>
                      {isLimitReached && (
                        <UncontrolledTooltip target="add-station-btn">
                          {t("Limit reached. Upgrade to add more.")}
                        </UncontrolledTooltip>
                      )}
                    </>
                  ) : null}

                  {selectedSiteId !== "All" && (
                    <Button
                      color="info"
                      onClick={() => navigate("/station-experience")}
                      className="d-flex align-items-center justify-content-center"
                      style={{ padding: '0.4rem 2rem', whiteSpace: 'nowrap', fontSize: "13px" }}
                    >
                      <i className="ri-list-settings-line me-1"></i> {t("Advanced Distribution")}
                    </Button>
                  )}
                </div>
                <div className="d-flex flex-column flex-md-row align-items-stretch gap-2 w-100 px-2" style={{ flex: '0 0 60%' }}>
                  <div className="d-flex align-items-center gap-2 w-100">
                    <h6 className="text-nowrap mb-0">Search: </h6>
                    <div className="flex-grow-1">
                      <SearchBar
                        submitMode
                        onSearch={searchHandler}
                        placeholder="Search kitchens by name or token..."
                      />
                    </div>
                  </div>
                  {sites.length > 0 && (
                    <div className="d-flex align-items-center gap-2 w-100">
                      <h6 className="text-nowrap mb-0">Select Site: </h6>
                      <select
                        className="form-control flex-grow-1"
                        value={selectedSiteId}
                        onChange={handleSiteSelect}
                      >
                        <option key={"all"} value={"All"}>
                          {"All"}
                        </option>
                        {sites.map((site) => (
                          <option key={site.site_id} value={site.site_id}>
                            {site.site_id} - {site.name}
                          </option>
                        ))}
                      </select>
                    </div>
                  )}
                </div>

              </div >
            )
            }
          </div>
        }
        data={kitchens} // Display current paginated data
        columns={columns}
        loading={isLoading}
        paginationTotalRows={totalRows}
        onChangePage={onChangePage}
        // onChangeRowsPerPage={onChangeRowsPerPage}
        onHeaderDeleteBtnClick={() => {
          alert("Soon");
        }}
        // onRowEditBtnClick={toggleEditKitchenModal}
        // onRowDeleteBtnClick={toggleDeleteKitchenModal}
        onSearchIconClick={searchHandler}
        actionColWidth="150px"
        showSearch={false}
        showActionColumn={canEditKitchen}
        showSubHeader={false}
        showActionButtons={false}
        customActionBtns={(row) => (
          <>
            <button
              className="btn btn-sm btn-info"
              onClick={() => {
                toggleManageStationWizard(row);
              }}
              title="Manage Station Assignments"
            >
              <i className="ri-settings-4-line"></i>{" "}
            </button>

            <button
              className="btn btn-sm btn-warning"
              onClick={() => {
                toggleEditKitchenModal(row);
              }}
              title="Edit"
            >
              <i className="ri-edit-fill"></i>{" "}
            </button>

            <button
              className="btn btn-sm btn-danger"
              onClick={() => {
                showConfirm(
                  () => {
                    deleteKitchenFun(row.kitchen_id);
                  },
                  () => {
                    console.log("Cancelled");
                  },
                  "Confirmation", // Title of the confirmation dialog
                  `Are you sure you want to delete kitchen ${row?.name} (id: ${row?.kitchen_id})?` // Question displayed in the dialog
                );
              }}
              title="Delete"
            >
              <i className="ri-delete-bin-line"></i>
            </button>
          </>
        )}
      />

      {/* <Pagination
        currentPage={currentPage}
        totalRows={kitchens.length}
        rowsPerPage={rowsPerPage}
        onPageChange={onPageChange}
      /> */}

      {
        showAddKitchenModal && !showSiteError && (
          <AddKitchen
            siteList={sites}
            toggleAddKitchenModal={toggleAddKitchenModal}
            showAddKitchenModal={showAddKitchenModal}
          />
        )
      }
      {
        showOpeningHoursModal && (
          <OpeningHours
            isOpen={showOpeningHoursModal}
            toggle={() => setshowOpeningHoursModal(!showOpeningHoursModal)}
            info={selectedInfo}
          />
        )
      }
      {
        showTokenModal && (
          <ShowToken
            kitchenId={kitchenId}
            showTokenModal={showTokenModal}
            canEditKitchen={canEditKitchen}
            toggleShowTokenModal={() => setShowTokenModal(!showTokenModal)}
            selectedToken={selectedToken}
          />
        )
      }
      {
        selectedRow && (
          <EditKitchen
            siteList={sites}
            toggleEditKitchenModal={toggleEditKitchenModal}
            showEditKitchenModal={showEditKitchenModal}
            info={selectedRow}
          />
        )
      }

      {
        selectedRow && showManageStationWizard && (
          <ManageStationView
            siteId={selectedRow.site_id}
            kitchenId={selectedRow.kitchen_id}
            onClose={() => setShowManageStationWizard(false)}
          />
        )
      }

      <PlanUpgradeModal
        isOpen={showUpgradeModal}
        toggle={toggleUpgradeModal}
      />
    </>
  );
};

export default Kitchens;
